<template>
  <div class="container py-3">
    <div class="card">
      <div class="row row-eq-height">
        <div class="col-12 col-md-5 hidden-sm profile-image">
          <img :src="user.profile_picture_path" class="img-responsive w-100" alt="">
        </div>
        <div class="col-12 col-md-7">
          <div class="detail">
            <span class="name">{{ user.name }}</span><span v-if="user.uuid === authUser.uuid"> (you)</span><br>
            <div class="badges">
              <span class="kt-badge kt-badge--warning kt-badge--inline kt-badge--pill kt-badge--rounded">
                <span v-if="user.is_super_admin"><i class="fa fa-star" /> Super Admin</span>
                <span v-else-if="user.is_organisation_admin"><i class="fa fa-star" /> Org Admin</span>
                <span v-else-if="user.is_admin"><i class="fa fa-star" /> Admin</span>
                <span v-else><i class="fa fa-lock" /> Standard</span>
              </span>
              <span v-if="user.status" class="kt-badge kt-badge--success kt-badge--inline kt-badge--pill kt-badge--rounded">Enabled</span>
              <span v-else class="kt-badge kt-badge--danger kt-badge--inline kt-badge--pill kt-badge--rounded">Disabled</span>
            </div>
          </div>

          <div v-if="can_edit_user" class="dropdown dropup">
            <button id="dropdownMenuButton" class="btn btn-ss w-75 dropdown-toggle"
                    type="button"
                    data-toggle="dropdown" aria-haspopup="true"
                    aria-expanded="false">
              Actions
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <a class="dropdown-item" :href="editPreferencesUrl(user)">
                <i class="la la-lock" />Permissions
              </a>
              <a v-if="!sidebar" class="dropdown-item" :href="editUserUrl(user)">
                <i class="la la-pencil-square" />Edit User
              </a>

              <div v-if="inAdminArea && authUser.is_super_admin && !user.is_super_admin" class="dropdown-item">
                <a href="javascript:void(0);"
                   class="kt-font-warning"
                   @click="makeSuperAdmin()">
                  <i class="kt-font-warning la la-star" /> Make Super Admin
                </a>
              </div>

              <div v-if="authUser.is_organisation_admin && !user.is_super_admin && !user.is_organisation_admin" class="dropdown-item ">
                <a href="javascript:void(0);"
                   class="kt-font-warning"
                   @click="makeOrgAdmin()">
                  <i class="kt-font-warning la la-star" /> Make Org Admin
                </a>
              </div>
              <div v-if="authUser.is_admin && !user.is_super_admin && (!user.is_admin || user.is_organisation_admin)" class="dropdown-item">
                <a href="javascript:void(0);"
                   class="kt-font-warning"
                   @click="makeAdmin()">
                  <i class="kt-font-warning la la-star" /> Make Admin
                </a>
              </div>

              <div v-if="authUser.is_admin && !user.is_super_admin && !user.is_standard" class="dropdown-item">
                <a href="javascript:void(0);"
                   class="kt-font-warning"
                   @click="makeStandard()">
                  <i class="kt-font-warning la la-star" /> Make Standard
                </a>
              </div>

              <div v-if="authUser.is_admin && !user.is_super_admin" class="dropdown-item">
                <a v-if="user.status" href="javascript:void(0);"
                   class="kt-font-danger"
                   @click="toggleStatus()">
                  <i class="kt-font-danger la la-toggle-off" /> Disable
                </a>
                <a v-else-if="!user.status" href="javascript:void(0);"
                   class="kt-font-success"
                   @click="toggleStatus()">
                  <i class="kt-font-success la la-toggle-on" /> Enable
                </a>
              </div>

              <div class="dropdown-divider" />

              <a class="dropdown-item text-ss-danger" href="javascript:void(0)" @click="deleteUser()">
                <i class="la la-trash" />Delete
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import UserCardMixin from "VueMixins/UserCardMixin";
export default {
  mixins: [UserCardMixin],
  props: {
    sidebar: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      required: true,
    },
    authUser: {
      type: Object,
      required: true,
    },
    inAdminArea: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    can_edit_user() {
      if (this.authUser.is_super_admin) return true;

      if (
        this.authUser.is_organisation_admin &&
        (!this.user.is_super_admin && !this.user.is_organisation_admin)
      ) {
        return true;
      }

      if (this.authUser.is_admin && !this.user.is_admin) return true;

      return false;
    },
  },
  methods: {
    makeAdmin() {
      EventBus.$emit('make-admin', this.user);
    },
    makeOrgAdmin() {
      EventBus.$emit('make-organisation-admin', this.user);
    },
    makeSuperAdmin() {
      EventBus.$emit('make-super-admin', this.user);
    },
    makeStandard() {
      EventBus.$emit('make-standard', this.user);
    },
    toggleStatus() {
      EventBus.$emit('toggle-active-status', this.user);
    },
    deleteUser() {
      EventBus.$emit('delete-user', this.user);
    },
  },
};
</script>

<style scoped lang="scss">

    .profile-image {
        background-size:contain;
        background-position:center;
        background-repeat:none;
    }

    .detail {
        padding-top:10px;
        padding-bottom:10px;
        text-align:center;
    }

    .card {
        .row {
            display: flex;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
        }
    }

    .badges {
        margin-top:10px;
    }

    .dropdown {
        text-align:center;
        padding-bottom:10px;
    }

</style>
